// Theme: tropic-noise
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'tropic-noise',
  name: 'TROPIC NOISE',
  tagline: 'TROPIC NOISE',
  description: 'Verde tropical vibrante com leitura limpa para uso diario.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0F1F14', '#1A2F1F', '#A3E635', '#DCFCE7'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-tropic-noise'
  },
  colorVars: {
    '--accent': '#A3E635',
    '--accent-foreground': '#0F1F14',
    '--background': '#0F1F14',
    '--border': '#3A7A5A',
    '--card': '#1A2F1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DCFCE7',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1F14',
    '--foreground': '#DCFCE7',
    '--hold-fill': '#A3E635',
    '--input': '#3A7A5A',
    '--modal-bg': '#0F1F14',
    '--modal-border': '#3A7A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A5A',
    '--muted-foreground': '#DCFCE7',
    '--nav-active': '#A3E635',
    '--nav-bg': '#1A2F1F',
    '--popover': '#1A2F1F',
    '--popover-foreground': '#DCFCE7',
    '--primary': '#A3E635',
    '--primary-foreground': '#0F1F14',
    '--ring': '#A3E635',
    '--secondary': '#3A7A5A',
    '--secondary-foreground': '#DCFCE7',
    '--streak': '#A3E635',
    '--success': '#22c55e',
    '--success-foreground': '#0F1F14',
    '--xp': '#A3E635',
    '--xp-bg': '#1A2F1F'
  },
  resolvedVars: {
    '--accent': '#A3E635',
    '--accent-foreground': '#0F1F14',
    '--accent-foreground-hsl': '139 35% 9%',
    '--accent-foreground-oklch': 'from #0F1F14 l c h',
    '--accent-hsl': '83 78% 55%',
    '--accent-oklch': 'from #A3E635 l c h',
    '--background': '#0F1F14',
    '--background-hsl': '139 35% 9%',
    '--background-oklch': 'from #0F1F14 l c h',
    '--border': '#3A7A5A',
    '--border-hsl': '150 36% 35%',
    '--border-oklch': 'from #3A7A5A l c h',
    '--border-w': '1px',
    '--card': '#1A2F1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DCFCE7',
    '--card-foreground-hsl': '141 84% 93%',
    '--card-foreground-oklch': 'from #DCFCE7 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '134 29% 14%',
    '--card-oklch': 'from #1A2F1F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1F14',
    '--destructive-foreground-hsl': '139 35% 9%',
    '--destructive-foreground-oklch': 'from #0F1F14 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#DCFCE7',
    '--foreground-hsl': '141 84% 93%',
    '--foreground-oklch': 'from #DCFCE7 l c h',
    '--hold-fill': '#A3E635',
    '--hold-fill-hsl': '83 78% 55%',
    '--hold-fill-oklch': 'from #A3E635 l c h',
    '--input': '#3A7A5A',
    '--input-hsl': '150 36% 35%',
    '--input-oklch': 'from #3A7A5A l c h',
    '--modal-bg': '#0F1F14',
    '--modal-bg-hsl': '139 35% 9%',
    '--modal-bg-oklch': 'from #0F1F14 l c h',
    '--modal-border': '#3A7A5A',
    '--modal-border-hsl': '150 36% 35%',
    '--modal-border-oklch': 'from #3A7A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A5A',
    '--muted-foreground': '#DCFCE7',
    '--muted-foreground-hsl': '141 84% 93%',
    '--muted-foreground-oklch': 'from #DCFCE7 l c h',
    '--muted-hsl': '150 36% 35%',
    '--muted-oklch': 'from #3A7A5A l c h',
    '--nav-active': '#A3E635',
    '--nav-active-hsl': '83 78% 55%',
    '--nav-active-oklch': 'from #A3E635 l c h',
    '--nav-bg': '#1A2F1F',
    '--nav-bg-hsl': '134 29% 14%',
    '--nav-bg-oklch': 'from #1A2F1F l c h',
    '--popover': '#1A2F1F',
    '--popover-foreground': '#DCFCE7',
    '--popover-foreground-hsl': '141 84% 93%',
    '--popover-foreground-oklch': 'from #DCFCE7 l c h',
    '--popover-hsl': '134 29% 14%',
    '--popover-oklch': 'from #1A2F1F l c h',
    '--primary': '#A3E635',
    '--primary-foreground': '#0F1F14',
    '--primary-foreground-hsl': '139 35% 9%',
    '--primary-foreground-oklch': 'from #0F1F14 l c h',
    '--primary-hsl': '83 78% 55%',
    '--primary-oklch': 'from #A3E635 l c h',
    '--radius': '10px',
    '--ring': '#A3E635',
    '--ring-hsl': '83 78% 55%',
    '--ring-oklch': 'from #A3E635 l c h',
    '--secondary': '#3A7A5A',
    '--secondary-foreground': '#DCFCE7',
    '--secondary-foreground-hsl': '141 84% 93%',
    '--secondary-foreground-oklch': 'from #DCFCE7 l c h',
    '--secondary-hsl': '150 36% 35%',
    '--secondary-oklch': 'from #3A7A5A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#A3E635',
    '--streak-hsl': '83 78% 55%',
    '--streak-oklch': 'from #A3E635 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F1F14',
    '--success-foreground-hsl': '139 35% 9%',
    '--success-foreground-oklch': 'from #0F1F14 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(83 78% 55% / 0.15)',
    '--xp': '#A3E635',
    '--xp-bg': '#1A2F1F',
    '--xp-bg-hsl': '134 29% 14%',
    '--xp-bg-oklch': 'from #1A2F1F l c h',
    '--xp-hsl': '83 78% 55%',
    '--xp-oklch': 'from #A3E635 l c h'
  }
}
